module.exports = __webpack_public_path__ + "assets/img/bro2.c9c92994.png";